/**
 * Resolves the vehicle id, engine id, transmission id y traction id from a given
 * set of vehicle, engine, transmission and traction combination.
 *
 * @param object vehicle Selected vehicle
 * @param object|null engine Selected engine
 * @param object|null transmission Selected object
 * @param object|null traction Selected object
 */
const getVehicleAttributeIds = (vehicle, engine, transmission, traction) => {
  const attributes = {
      vehicle_id: vehicle.id,
    },
    engines = Object.keys(vehicle.engines),
    transmissions = Object.keys(vehicle.transmissions),
    tractions = Object.keys(vehicle.tractions);

  if (engine) {
    attributes.engine_id = engine.id;
  } else {
    if (engines.length > 1) {
      throw new Error('Motor no seleccionado.');
    }

    attributes.engine_id = parseInt(engines[0], 10);
  }

  if (transmission) {
    attributes.transmission_id = transmission.id;
  } else {
    if (transmissions.length > 1) {
      throw new Error('Transmissión no seleccionada.');
    }

    attributes.transmission_id = parseInt(transmissions[0], 10);
  }

  if (traction) {
    attributes.traction_id = traction.id;
  } else {
    if (tractions.length > 1) {
      throw new Error('Tracción no seleccionada.');
    }

    attributes.traction_id = parseInt(tractions[0], 10) || 0;
  }

  return attributes;
};

/**
 * Build the shift request object from the user selected objects.
 *
 * @param Object params
 *
 * @return Object
 */
function buildRequestObject({
  workshop = {},
  vehicle,
  engine,
  transmission,
  traction,
  services = [],
  date,
  hour,
}) {
  const attributes = getVehicleAttributeIds(vehicle, engine, transmission, traction);

  attributes.services = services.map(service => service.id);

  attributes.date = date;

  attributes.hour = hour;

  attributes.workshop_id = workshop.id;

  return attributes;
}

export { getVehicleAttributeIds, buildRequestObject };
